import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import { FreeDownloadButton as DownloadButton } from '../../buttons/DownloadButton';
import { useSelector } from 'react-redux';
import { getStashFolder, getStashNext, getStashPrev } from '../../../DeviationPage/redux/selectors';
import { URLS, Url } from '@wix/da-url';
import s from './StashActionBar.scss';
const StashActionBar = ({ deviation, isOwner })=>{
    const { isEditable, isDeletable, isDownloadable } = useDeviationAttributes(deviation, isOwner);
    let next = useSelector(getStashNext);
    let prev = useSelector(getStashPrev);
    const folder = useSelector(getStashFolder);
    let toFolder = undefined;
    if (folder === null || folder === void 0 ? void 0 : folder.hasSubfolders) {
        toFolder = Url.stashFolderLink(folder.folderId);
    }
    next = next ? Url.stashItemLink(next) : undefined;
    prev = prev ? Url.stashItemLink(prev) : undefined;
    var _ref, _ref1;
    const redirectTo = (_ref1 = (_ref = next !== null && next !== void 0 ? next : prev) !== null && _ref !== void 0 ? _ref : toFolder) !== null && _ref1 !== void 0 ? _ref1 : URLS.STASH;
    return /*#__PURE__*/ React.createElement(ActionBarStrip, null, /*#__PURE__*/ React.createElement(CentralColumn, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-side']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['right-side']
    }, isDeletable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation,
        redirectTo: redirectTo
    })), isEditable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })), isDownloadable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DownloadButton, {
        deviation: deviation
    })))));
};
StashActionBar.displayName = 'StashActionBar';
export default StashActionBar;
